import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, ShieldCheck } from 'lucide-react';
import BackOfficeReferralWorkspace from './BackOfficeReferralWorkspace';

// Single, existing CRM review workflow: no duplicate approvals, no privileged
// calls to Profiles, and no bypass of Back Office server-side staff permissions.
export default function ProfilesReferralReview() {
  const { id } = useParams();
  return <main className="profiles-review-workspace">
    <nav className="profiles-review-breadcrumb" aria-label="Profiles administration">
      <Link to="/profiles/admin"><ArrowLeft size={16} aria-hidden="true" /> Profiles administration</Link>
      <span aria-hidden="true">/</span>
      <span>Back Office review</span>
    </nav>
    <div className="profiles-review-context">
      <ShieldCheck size={18} aria-hidden="true" />
      <div>
        <strong>Profiles · governed Back Office review</strong>
        <p className="govuk-body">The existing CRM case workflow handles verification, evidence, decisions and audit history. Opening a review does not automatically approve a profile or change customer data.</p>
      </div>
    </div>
    {id ? <BackOfficeReferralWorkspace /> : <p className="govuk-body" role="alert">A valid referral reference is required.</p>}
  </main>;
}
